<template>
    <div class="zz" :class="{ active: isShowFeedback }">
        <div class="modalBox">
            <div class="modal">
                <img
                    class="shikanBanner"
                    src="~@/assets/shikan-banner.png"
                    alt=""
                />
                <div class="btn" @click="goPay()">立即购买课程</div>
                <div class="btn" @click="changeShowReason()">再考虑看看</div>
                <div class="reasonBox" :class="{ active: isShowReason }">
                    <div class="no-buy-title">您暂时不购买的原因：</div>
                    <van-checkbox-group class="checkboxBox" v-model="feeling">
                        <van-checkbox name="内容不喜欢">
                            内容不喜欢
                        </van-checkbox>
                        <van-checkbox name="听不懂"> 听不懂 </van-checkbox>
                        <van-checkbox name="内容和预期有出入">
                            内容和预期有出入
                        </van-checkbox>
                        <van-checkbox name="价格太贵"> 价格太贵 </van-checkbox>
                        <van-checkbox name="其他原因，欢迎反馈">
                            其他原因，欢迎反馈
                        </van-checkbox>
                    </van-checkbox-group>
                    <textarea
                        v-iosInput
                        class="other_reason"
                        placeholder="其他原因"
                        v-model="other"
                    ></textarea>
                    <div class="btn submit" @click="submit()">提交</div>
                </div>
            </div>
            <img
                class="close"
                @click="close()"
                src="~@/assets/close.png"
                alt=""
            />
        </div>
    </div>
</template>

<script>
import rx from "../../_rx";
import videoCourseService from "../../service/video-course.service";
import { Toast } from "vant";
export default {
    name: "feedback",
    data() {
        return {
            noBuyReason: undefined,
            isShowFeedback: false,
            isShowReason: false,
            goodsId: "",
            goodsCode: "",
            feeling: [],
            other: "",
            episodeId: "",
            loading: false
        };
    },
    mounted() {
        rx.on("showFeedback", obj => {
            this.isShowFeedback = true;
            this.goodsId = obj.goodsId;
            this.goodsCode = obj.goodsCode;
            this.episodeId = obj.episodeId;
        });
    },
    methods: {
        changeShowReason() {
            this.isShowReason = !this.isShowReason;
        },
        close() {
            this.isShowReason = false;
            this.isShowFeedback = false;
            rx.emit("reloadVideo");
        },
        submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            videoCourseService
                .freeSeeFeeling({
                    studyId: this.goodsId,
                    episodeId: this.episodeId,
                    feeling: this.feeling,
                    other: this.other
                })
                .then(() => {
                    Toast("提交成功");
                    this.loading = false;
                    this.isShowFeedback = false;
                    rx.emit("reloadVideo");
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        goPay() {
            this.isShowFeedback = false;
            this.$router.push({
                path: `/pay/${this.goodsCode}`,
                query: { id: this.goodsId }
            });
        }
    }
};
</script>

<style lang="scss" scoped src="./feedback.scss">
</style>
